import React from "react";

import { i18n } from "../../../translate/i18n";

function SummaryCard({ title, value, hint, icon, toneClassName }) {
	return (
		<div className="card h-full">
			<div className="card-body flex items-start justify-between gap-4">
				<div className="min-w-0">
					<p className="mb-1 text-xs font-semibold uppercase tracking-wide text-default-500">
						{title}
					</p>
					<p className="m-0 text-2xl font-semibold text-default-800 dark:text-default-100">
						{value}
					</p>
					{hint ? (
						<p className="mt-2 mb-0 text-sm text-default-500">{hint}</p>
					) : null}
				</div>
				<div
					className={`flex size-12 shrink-0 items-center justify-center rounded-2xl ${toneClassName}`}
				>
					{icon}
				</div>
			</div>
		</div>
	);
}

function formatCurrency(value) {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
	}).format(Number(value) || 0);
}

export default function TransactionSummaryCards({ summary }) {
	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
			<SummaryCard
				title={i18n.t("transactions.summary.total")}
				value={summary?.total ?? 0}
				hint={i18n.t("transactions.summary.totalHint")}
				toneClassName="bg-primary/10 text-primary"
				icon={
					<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
						<rect x="2" y="5" width="20" height="14" rx="2" />
						<path d="M2 10h20" />
					</svg>
				}
			/>
			<SummaryCard
				title={i18n.t("transactions.summary.pending")}
				value={summary?.pending ?? 0}
				hint={i18n.t("transactions.summary.pendingHint")}
				toneClassName="bg-warning/10 text-warning"
				icon={
					<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
						<circle cx="12" cy="12" r="10" />
						<path d="M12 6v6l4 2" />
					</svg>
				}
			/>
			<SummaryCard
				title={i18n.t("transactions.summary.received")}
				value={summary?.received ?? 0}
				hint={i18n.t("transactions.summary.receivedHint")}
				toneClassName="bg-success/10 text-success"
				icon={
					<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
						<path d="M20 6 9 17l-5-5" />
					</svg>
				}
			/>
			<SummaryCard
				title={i18n.t("transactions.summary.receivedMonth")}
				value={formatCurrency(summary?.receivedAmountMonth)}
				hint={i18n.t("transactions.summary.receivedMonthHint")}
				toneClassName="bg-info/10 text-info"
				icon={
					<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
						<path d="M12 2v20" />
						<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
					</svg>
				}
			/>
		</div>
	);
}
